<template>
  <a-dropdown placement="bottom">
    <div class="dol-switch-lang">
<!--      <img class="locale-icon" :src="iconMap[$i18n.locale] || iconMap.global" />-->

      <div class="locale-info">
        <img class="locale-icon" :src="iconMap[$i18n.locale] || iconMap.global" />
        <span>{{ langMap[$i18n.locale] || $i18n.locale }}</span>
      </div>
    </div>
    <template #overlay>
      <a-menu @click="changeLang">
        <a-menu-item v-for="lang in langType" :key="lang._id">
          <img class="locale-icon" :src="iconMap[lang._id] || iconMap.global" />
          {{ lang.label }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '@/store/index';

import globalIcon from '../../../../public/static/lang/global.svg';
import zhIcon from '../../../../public/static/lang/zh.svg';
import enIcon from '../../../../public/static/lang/en.svg';
import ruIcon from '../../../../public/static/lang/ru.svg';
import esIcon from '../../../../public/static/lang/es.svg';

const iconMap = {
  global: globalIcon,
  zh: zhIcon,
  en: enIcon,
  ru: ruIcon,
  es: esIcon,
}

export default {
  name: "dol-switch-lang",
  data(){
    return { iconMap };
  },
  computed: {
    ...mapGetters(['langType']),
    langMap(){
      let map = {};
      this.langType.forEach(lang => map[lang._id] = lang.label);
      return map;
    },
  },
  methods: {
    changeLang({key}){
      store.commit('lang/changeLang', key);
    }
  },
};
</script>

<style lang="scss">
.dol-switch-lang {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  > .locale-icon{
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .locale-info{
    font-size: 13px;
    line-height: 20px;
    padding: 6px 13px;
    //background: rgba(0,0,0,0.06);
    background: #F3F5F7;
    border-radius: 4px;
    display: flex;
    align-items: center;
    min-width: 100px;
    justify-content: center;

    .locale-icon{
      margin-right: 5px;
    }
    .dol-icon-global-outlined{
      margin-right: 5px;
    }
    .dol-icon-down-outlined{
      margin-left: 2px;
      font-size: 10px;
    }
  }
}
</style>
